import { PERMISSION_API_URL } from '@/services/constants';
import axiosClient from '../axiosClient';

const PermissionServices = {
  fetchPermissions: async (params: any) => {
    try {
      const response = await axiosClient.get(`${PERMISSION_API_URL}`, {
        params
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  createPermission: async (body: any) => {
    try {
      const response = await axiosClient.post(`${PERMISSION_API_URL}`, body);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  deletePermission: async (params: any) => {
    try {
      const response = await axiosClient.delete(`${PERMISSION_API_URL}`, {
        params
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  deleteBulkPermission: async (params: any) => {
    try {
      const response = await axiosClient.delete(`${PERMISSION_API_URL}/bulk`, {
        params
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  updatePermission: async (body: any, permId: any) => {
    try {
      const response = await axiosClient.put(`${PERMISSION_API_URL}/${permId}`, body);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  downloadPermission: async () => {
    try {
      const response = await axiosClient.get(`${PERMISSION_API_URL}/download`);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  downloadCsv: async () => {
    try {
      const response = await axiosClient.get(`${PERMISSION_API_URL}/downloadsamplefile`);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  uploadCsv: async (params: any) => {
    try {
     
      const response = await axiosClient.post(`${PERMISSION_API_URL}/UploadCsv`, params?.data, {
        headers: {
          'Content-Type': 'application/JSON'
        },
        params: {
          dom_name: params?.dom_name,
          org_name:params?.org_name,
          app_name:params?.app_name,
          app_type:params?.app_type,
          perm_type:params?.perm_type,
          created_by: params?.created_by,
          modified_by: params?.modified_by,
          status: params?.status
        }
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  }
};

export default PermissionServices;
